import React, { useContext, useEffect, useRef, useState } from "react";
// import { useParams, useLocation } from "react-router-dom";
import usePhoneNumber from "../customHooks/usePhoneNumber";
import { TimesheetsContext } from "../providers/TimesheetsProvider";
import { JobsheetsContext } from "../providers/JobsheetsProvider";
import { QuotesContext } from "../providers/QuotesProvider";
import { useSectionedData } from "../customHooks/useSectionedData";
import { useGlobalSearchData } from "../customHooks/useGlobalSearchData";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useEditMode } from "../customHooks/useEditMode";
import Loading from "./Loading";

import PhoneIcon from "@mui/icons-material/Phone";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import "../css/incomingCallPage.scss";
import ContactsList from "./ContactsList";
import Footer from "./Footer";
import { knownContactsArr, knownContacts } from "../popData";

function IncomingCall(props) {
  const phoneNumber = usePhoneNumber();

  const [copying, setCopying] = useState(false);
  const [showCopyMessage, setShowCopyMessage] = useState(false);

  // Container ref is useful for the edit mode stuff. Might need it if I decide to add different
  // functionality to this page for phone calls coming in.
  const containerRef = useRef(null);

  // Don't think I need the slider stuff.
  // const { sliders, setSliderId, sliderId } = useContext(SlidersContext);

  useEffect(() => {
    // Only show the copied notification for 1 second
    const timer = setTimeout(() => {
      setShowCopyMessage(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [copying]);

  function copyPhoneNumber() {
    try {
      let type = "text/plain";
      let ClipboardItem = window.ClipboardItem;
      let blob = new Blob([phoneNumber], { type });
      let copyData = [new ClipboardItem({ [type]: blob })];

      navigator.clipboard.write(copyData).then(
        function () {
          /* success */
          setCopying((prevState) => !prevState);
          setShowCopyMessage(true);
        },
        function (err) {
          /* failure */
          console.log("in fail copy", err);
        }
      );
    } catch (error) {
      console.log("error", error);
    }
  }

  return (
    <div ref={containerRef} className="incomingCallPage">
      <div className="callerIdBar">
        <PhoneIcon className="icon" />
        <p>{phoneNumber}</p>
        <button onClick={copyPhoneNumber} title="copy">
          <ContentCopyIcon className="icon" />
        </button>
        {showCopyMessage && (
          <p className="copied-message">copied to clipboard</p>
        )}
      </div>

      {/* <StatusFilters
        options={sortAndFilterOptions}
        setOptions={setSortAndFilterOptions}
        primaryType={"timesheets"}
      /> */}

      <>
        {/* Possible Contacts (Jobsheets & Quotes)>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
        {/* <div className={`contactsContainer ${inEditMode ? "dimContacts" : ""}`}> */}

        {knownContactsArr.includes(phoneNumber) ? (
          <div className={`contactsContainer`}>
            <div className="knownContactCard">
              <div className="info">
                <div className="infoLine name">
                  <ContactMailIcon className="icon" />
                  <p>{knownContacts[phoneNumber]?.name}</p>
                </div>
                <div className="infoLine name">
                  <PhoneIcon className="icon" />
                  <p>{knownContacts[phoneNumber]?.number}</p>
                </div>
              </div>
              <div className="picture">
                <img
                  src="hes_logo.png"
                  alt="Contact profile pic"
                  width={110}
                  height={72}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className={`contactsContainer`}>
            <ContactsList phoneNumber={phoneNumber} />
          </div>
        )}
        {/* Global Search Data <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
      </>

      <Footer back={false} title="Incoming Call" backTo={"/"}>
        {/* <FooterBtn
          title={tooltips.edit}
          cb={() => toggleEditMode(document.body)}
          show={true}
        >
          <EditIcon style={{ fontSize: 25 }} />
        </FooterBtn> */}

        {/* <FooterBtn title={tooltips.mapView} cb={mapView} show={showBin}>
            <LocationOnIcon style={{ fontSize: 30 }} />
          </FooterBtn> */}

        {/* {showBin && <CloneOptions clone={clone} inEditMode={inEditMode} />} */}

        {/* <FooterBtn
            title={tooltips.jobsheetConvert}
            cb={convertToJobsheets}
            show={showBin}
          >
            <RestoreIcon
              title="Convert to Jobsheets"
              style={{ fontSize: 28 }}
            />
            <span>J</span>
          </FooterBtn>

          <FooterBtn
            title={tooltips.quoteConvert}
            cb={convertToQuotes}
            show={showBin}
          >
            <RestoreIcon title="Convert to Quotes" style={{ fontSize: 28 }} />
            <span>Q</span>
          </FooterBtn>

          <FooterBtn title={tooltips.bin} cb={deleteTimesheets} show={showBin}>
            <DeleteOutlinedIcon style={{ fontSize: 30 }} />
          </FooterBtn>

          <FooterBtn
            title={tooltips.createTimesheet}
            cb={addTimesheet}
            show={!showBin}
          >
            <AddIcon style={{ fontSize: 30 }} />
          </FooterBtn> */}
      </Footer>
    </div>
  );
}

export default IncomingCall;
